import React from 'react';
import "./button.scss";

export const Button = (props) => {
  return (
    <button className="button">
      <a
        target="_top"
        href="mailto:info@consultvision.cz"
        className="buttonLink"
      >
        {props.btnName}
      </a>
    </button>
  );
};
